import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/vacancy/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + `/vacancy/${id}`)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/vacancy', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/vacancy', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/vacancy/' + id)
  },

  async findAllByFilter(page, body) {
    const { data } = await repository.post(baseURL + `/vacancy/findAllByFilter/${page}`, body)
    return data
  },



  async findAllForTestScoreFilter(page, body, vacancyId) {
    const { data } = await repository.post(baseURL +
      `/vacancy/findAllByFilter/${page}${vacancyId ? '?vacancyId=' + vacancyId : ''}`, body)
    return data
  },
}
